<template>
  <div class="de-view-container" v-if="de">
    <div class="query-detail-row" v-for="msg in de.messages" :key="msg.id">
      <div class="field-container-left">
        <label class="query-label">
          {{ categoryText }}
        </label>
        <div class="selection">{{ msg.category }}</div>
      </div>

      <div class="field-container-right">
        <label class="query-label">
          {{ nameText }}
        </label>
        <div class="selection">{{ msg.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: "VmsgView",
    props: {
      deId: String,
      appId: String
    },
    computed: {
      ...mapState({
        apps: "apps",
        messages: "messages"
      }),
      categoryText() {
        return this.getMessageText(this.messages.APPROVED_NOTES_CATEGORY);
      },
      nameText() {
        return this.getMessageText(this.messages.NAME);
      },
      de() {
        let elem = this;
        let app = elem.apps.find(app => {
          return app.uuid === elem.appId;
        });

        return app.dataElements[elem.deId];
      }
    }
  };
</script>

<style scoped>
  .field-container-left,
  .field-container-right {
    display: flex;
  }

  .field-container-left {
    flex-basis: 40%;
  }

  .field-container-right {
    flex-basis: 60%;
  }

  .selection {
    display: inline-block;
  }

  .query-detail-row {
    display: flex;
  }

  .query-label {
    font-size: 0.85rem;
    font-weight: bold;
    flex-basis: 20%;
  }

  .field-container-left .query-label {
    flex-basis: 35%;
  }
</style>
